import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { adminListResources, adminDeleteResource } from "@/lib/api";
import { toast } from "sonner";
import { Plus, FileText, Image as ImgIcon } from "lucide-react";

export default function AdminResources() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");

  const load = () => { setLoading(true); adminListResources().then((d) => { setItems(d); setLoading(false); }); };
  useEffect(() => { load(); }, []);

  const remove = async (slug) => {
    if (!confirm(`Delete "${slug}"?`)) return;
    try { await adminDeleteResource(slug); toast.success("Deleted"); load(); } catch { toast.error("Failed"); }
  };

  const filtered = items.filter((r) => filter === "all" ? true : filter === "free" ? !r.premium : r.premium);

  return (
    <div data-testid="admin-resources">
      <div className="flex items-center justify-between flex-wrap gap-4 mb-10">
        <div>
          <div className="overline">Store</div>
          <h1 className="font-serif-editorial tight-track mt-4" style={{ fontSize: "clamp(2rem, 3.5vw, 3rem)", lineHeight: 1 }}>
            Resources
          </h1>
        </div>
        <Link to="/admin/resources/new" className="btn-olive" data-testid="new-resource-btn">
          <Plus size={14} /> New resource
        </Link>
      </div>

      <div className="flex gap-6 mb-8">
        {["all", "free", "premium"].map((f) => (
          <button
            key={f}
            onClick={() => setFilter(f)}
            data-testid={`resources-filter-${f}`}
            className="overline editorial-link"
            style={{ opacity: filter === f ? 1 : 0.55, color: "var(--olive)" }}
          >
            {f}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="opacity-60">Loading…</div>
      ) : (
        <div className="border-t" style={{ borderColor: "rgba(166,154,139,0.4)" }}>
          {filtered.length === 0 && <div className="py-10 opacity-60 font-serif-editorial text-xl">No resources.</div>}
          {filtered.map((r) => (
            <div key={r.slug} className="grid grid-cols-12 gap-4 items-center py-5 border-b" style={{ borderColor: "rgba(166,154,139,0.4)" }} data-testid={`admin-resource-row-${r.slug}`}>
              <div className="col-span-12 md:col-span-5">
                <div className="font-serif-editorial text-xl">{r.title}</div>
                <div className="overline mt-1 opacity-80">/{r.slug}</div>
              </div>
              <div className="col-span-6 md:col-span-2 overline">
                {r.premium ? `$${(r.price || 0).toFixed(2)}` : "Free"}
              </div>
              <div className="col-span-6 md:col-span-3 flex flex-col gap-1 text-xs opacity-70">
                <span className="flex items-center gap-2">
                  <FileText size={12} /> {r.pdf_path ? "PDF uploaded" : "No PDF"}
                </span>
                <span className="flex items-center gap-2">
                  <ImgIcon size={12} /> {r.image ? "Cover set" : "No cover"}
                </span>
              </div>
              <div className="col-span-12 md:col-span-2 flex gap-4 justify-start md:justify-end">
                <Link to={`/admin/resources/edit/${r.slug}`} className="overline editorial-link" data-testid={`edit-resource-${r.slug}`}>Edit</Link>
                <button onClick={() => remove(r.slug)} className="overline editorial-link" data-testid={`delete-resource-${r.slug}`} style={{ color: "#8a3a3a" }}>Delete</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
